import { Routes, Route } from '@angular/router';
import { LayoutPublicComponent } from './public.component';

/**
 * Provides helper methods to create routes.
 */
export class LayoutPublic {
  /**
   * Creates routes using the layout default component
   * @param routes The routes to add.
   * @return The new route using shell as the base.
   */
  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: LayoutPublicComponent,
      children: routes,
      data: { reuse: true }
    };
  }
}
